export interface OrganizationOption {
  id: string
  name: string
  eligibleAgentsCount: number
  activeSessionsCount: number
  usersCount: number
}

export type BroadcastFailureChannel = 'session' | 'panel' | 'email'

export interface BroadcastFailure {
  orgName: string
  // null para falhas de painel/e-mail — o alvo é um grupo de usuários, não um agente.
  workerName: string | null
  channel: BroadcastFailureChannel
  count: number
  reason: string
}

export interface HistoryEntry {
  id: string
  title: string
  status: 'sending' | 'sent'
  createdAtLabel: string
  orgsCount: number
  agentsCount: number
  sessionsTotal: number
  sessionsDelivered: number
  sessionsFailed: number
  // Painel e e-mail são contados por canal: um usuário com os dois canais
  // gera duas entregas — somar como "usuários" dobraria os números.
  panelTotal: number
  panelDelivered: number
  panelFailed: number
  emailTotal: number
  emailDelivered: number
  emailFailed: number
  failures: BroadcastFailure[]
}

export type BroadcastScope = 'all' | 'custom'

// Type alias (not interface) so it satisfies Inertia useForm's FormDataType constraint.
export type BroadcastChannels = {
  panel: boolean
  email: boolean
}

// Type alias (not interface) so it satisfies Inertia useForm's FormDataType constraint.
export type BroadcastFormData = {
  title: string
  content: string
  org_scope: BroadcastScope
  organization_ids: string[]
  channels: BroadcastChannels
}

export interface Reach {
  orgs: number
  agents: number
  sessions: number
  users: number
}

export function formatCount(value: number): string {
  return value.toLocaleString('pt-BR')
}

// "painel", "e-mail" ou "painel + e-mail" — rótulo curto dos canais adicionais ativos.
export function channelsLabel(channels: BroadcastChannels): string {
  return [channels.panel ? 'painel' : null, channels.email ? 'e-mail' : null].filter(Boolean).join(' + ')
}
